import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { ContactInfo, ContactInfoService } from '../../../services/contact-info.service';

@Component({
    selector: 'app-contact',
    imports: [CommonModule],
    templateUrl: './contact.component.html',
    styleUrl: './contact.component.scss'
})
export class ContactComponent {
  contact!: ContactInfo;
  formUrl!: SafeResourceUrl;

  constructor(private titleService: Title, private themeService: ThemeService, private contactSvc: ContactInfoService, private sanitizer: DomSanitizer) {
    this.titleService.setTitle("Contacto");
    this.themeService.setTitle("Contacto");
    this.contactSvc.get().subscribe(c => {
      this.contact = c;
      this.formUrl = this.sanitizer.bypassSecurityTrustResourceUrl(c.contactFormUrl);
    });
  }
}
